const RESET_PASSWORD = "account/reset-password/reset-password";
const RESET_PASSWORD_SUCCESS = "account/reset-password/reset-password-success";
const RESET_PASSWORD_FAILED = "account/reset-password/reset-password-failed";
const UPDATE_PASSWORD = "account/reset-password/update-password";
const UPDATE_PASSWORD_FAILED = "account/reset-password/update-password-failed";
const UPDATE_PASSWORD_SUCCESS = "account/reset-password/update-password-success";
const CHANGE_PASSWORD = "account/reset-password/change-password";
const CHANGE_PASSWORD_FAILED = "account/reset-password/change-password-failed";
const CHANGE_PASSWORD_SUCCESS = "account/reset-password/change-password-success";
const resetPassword = (payload) => ({
  type: RESET_PASSWORD,
  payload
});
const resetPasswordSuccess = (payload) => ({
  type: RESET_PASSWORD_SUCCESS,
  payload
});
const resetPasswordFailed = (error) => ({
  type: RESET_PASSWORD_FAILED,
  error
});
const updatePassword = (payload) => ({
  type: UPDATE_PASSWORD,
  payload
});
const updatePasswordFailed = (error) => ({
  type: UPDATE_PASSWORD_FAILED,
  error
});
const updatePasswordSuccess = (payload) => ({
  type: UPDATE_PASSWORD_SUCCESS,
  payload
});
const changePassword = (payload) => ({
  type: CHANGE_PASSWORD,
  payload
});
const changePasswordFailed = (error) => ({
  type: CHANGE_PASSWORD_FAILED,
  error
});
const changePasswordSuccess = (payload) => ({
  type: CHANGE_PASSWORD_SUCCESS,
  payload
});
export {
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_FAILED,
  CHANGE_PASSWORD_SUCCESS,
  RESET_PASSWORD,
  RESET_PASSWORD_FAILED,
  RESET_PASSWORD_SUCCESS,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_FAILED,
  UPDATE_PASSWORD_SUCCESS,
  changePassword,
  changePasswordFailed,
  changePasswordSuccess,
  resetPassword,
  resetPasswordFailed,
  resetPasswordSuccess,
  updatePassword,
  updatePasswordFailed,
  updatePasswordSuccess
};
//# sourceMappingURL=actions.js.map
